import { Icon } from '@/components/ui/Icon'
import { useSnackbarStore } from '@/store/snackbar'
import { useEffect } from 'react'
import styles from './Snackbar.module.scss'

type SnackbarVariant = 'success' | 'error' | 'warning' | 'info'

const DURATION = 5000

const iconNameMap: Record<SnackbarVariant, string> = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info',
}

const iconColorMap: Record<SnackbarVariant, string> = {
  success: '#22c55e',
  error: '#ef4444',
  warning: '#f97316',
  info: '#0261ad',
}

export const Snackbar = () => {
  const message = useSnackbarStore((state) => state.message)
  const variant = useSnackbarStore((state) => state.variant)
  const hide = useSnackbarStore((state) => state.hide)

  useEffect(() => {
    if (!message) return

    const timer = setTimeout(() => {
      hide()
    }, DURATION)

    return () => clearTimeout(timer)
  }, [message, hide])

  if (!message) return null

  const classNames = [styles.snackbar, styles[variant]].join(' ')

  return (
    <div className={styles.container} data-testid="snackbar">
      <div className={classNames} data-testid="snackbar-content">
        <Icon
          name={iconNameMap[variant]}
          color={iconColorMap[variant]}
          size={20}
          className={styles.icon}
        />
        <p className={styles.message} data-testid="snackbar-message">
          {message}
        </p>
        <button
          className={styles.closeButton}
          onClick={hide}
          data-testid="snackbar-close"
        >
          <Icon
            name="x"
            color={iconColorMap[variant]}
            size={16}
            className={styles.closeIcon}
          />
        </button>
      </div>
    </div>
  )
}
